import moment from 'moment'

interface DateDiff {
  years: number
  months: number
  days: number
  isPast: boolean
}

export const calculateDateDifference = (
  startDate: moment.Moment,
  referenceDate: moment.Moment = moment()
): DateDiff => {
  const isPast = startDate.isBefore(referenceDate)
  // Determine the earlier and later dates
  const earlierDate = isPast ? startDate.clone() : referenceDate
  const laterDate = isPast ? referenceDate : startDate.clone()

  // Calculate the difference in years, months, and days
  const years = laterDate.diff(earlierDate, 'years')
  earlierDate.add(years, 'years') // Move the earlier date forward by the number of years

  const months = laterDate.diff(earlierDate, 'months')
  earlierDate.add(months, 'months') // Move the earlier date forward by the number of months

  const days = laterDate.diff(earlierDate, 'days')

  const result = {
    years,
    months,
    days,
    isPast,
  }

  return result
}
